const styles = {
  wrap: {
    display: "inline-flex",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    overflow: "hidden",
    backgroundColor: "#ffffff",
  },
  btn: {
    padding: "8px 16px",
    fontSize: "14px",
    fontWeight: "500",
    border: "none",
    backgroundColor: "#ffffff",
    color: "#6b7280",
    cursor: "pointer",
    transition: "all 0.15s ease",
    fontFamily: "inherit",
  },
  btnCompact: {
    padding: "6px 12px",
    fontSize: "13px",
  },
  btnActive: {
    backgroundColor: "#2563eb",
    color: "#ffffff",
  },
};

const SegmentControl = ({ options, value, onChange, compact = false, "aria-label": ariaLabel }) => (
  <div style={styles.wrap} role="group" aria-label={ariaLabel}>
    {options.map((option) => {
      const active = option.key === value;
      return (
        <button
          key={option.key}
          type="button"
          aria-pressed={active}
          style={{
            ...styles.btn,
            ...(compact ? styles.btnCompact : {}),
            ...(active ? styles.btnActive : {}),
          }}
          onClick={() => onChange(option.key)}
        >
          {option.label}
        </button>
      );
    })}
  </div>
);

export default SegmentControl;
